import Entity from '@/models/entities/Entity';
import { Size } from '@/models/entities/Size';

export class ShopifyProduct implements Entity {
  public id: number = 0;
  public title: string = '';
  public sizes: Size[] = [];

  constructor(initData: Partial<ShopifyProduct>) {
    Object.assign(this, initData);
  }
}
